// Development: localhost:4000
// Production: admin.creativeaiwriter.com
export const isDev =
  window.location.hostname === 'localhost' ||
  window.location.hostname.includes('localhost');
